// src/app/app-routing.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Import all components directly
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { IssuesComponent } from './pages/issues/issues.component';
import { PetitionsComponent } from './pages/petitions/petitions.component';
import { DonateComponent } from './pages/donate/donate.component';
import { VolunteerComponent } from './pages/volunteer/volunteer.component';
import { ContactComponent } from './pages/contact/contact.component';
import { NewsroomComponent } from './newsroom/newsroom.component';
import { PressReleaseDetailComponent } from './press-release-detail/press-release-detail.component';
import { IssueDetailComponent } from './issue-detail/issue-detail.component';
import { LegislativeTrackerComponent } from './pages/legislative-tracker/legislative-tracker';
import { ReportCardComponent } from './pages/report-card/report-card';
import { EndorsementsComponent } from './pages/endorsements/endorsements.component';
import { EventsComponent } from './pages/events/events.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { CoalitionsComponent } from './pages/coalitions/coalitions.component';
import { PressComponent } from './pages/press/press.component';
import { FaqComponent } from './pages/faq/faq.component';
import { CompareComponent } from './pages/compare/compare.component';
import { PhoneBankComponent } from './pages/phone-bank/phone-bank.component';
import { MerchComponent } from './pages/merch/merch.component';
import { MayDaySignupComponent } from './pages/may-day-signup/may-day-signup.component';
import { Senate } from './pages/senate/senate';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'issues', component: IssuesComponent },
  { path: 'senate', component: Senate },
  { path: 'petitions', component: PetitionsComponent },
  { path: 'donate', component: DonateComponent },
  { path: 'volunteer', component: VolunteerComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'newsroom', component: NewsroomComponent },
  { path: 'newsroom/:idOrSlug', component: PressReleaseDetailComponent },
  { path: 'issues/:idOrSlug', component: IssueDetailComponent },
  { path: 'tracker',      component: LegislativeTrackerComponent },
  { path: 'report-card',  component: ReportCardComponent },
  { path: 'endorsements', component: EndorsementsComponent },
  { path: 'events',       component: EventsComponent },
  { path: 'coalitions',   component: CoalitionsComponent },
  { path: 'privacy',      component: PrivacyComponent },
  { path: 'press',        component: PressComponent },
  { path: 'faq',          component: FaqComponent },
  { path: 'compare',      component: CompareComponent },
  { path: 'phone-bank',   component: PhoneBankComponent },
  { path: 'merch',        component: MerchComponent },
  { path: 'may-day',      component: MayDaySignupComponent },
  { path: '**',           component: NotFoundComponent }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
